import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=b7f060fc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=b7f060fc&prod&scoped=true&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=b7f060fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f060fc",
  null
  
)

export default component.exports